import React from "react";
import { Mail, Phone, Printer } from "lucide-react";
import { COMPANY } from "../data/mock";
import { PhoneMock } from "./Illustrations";

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-white overflow-hidden">
      <div className="aaa-container grid md:grid-cols-2 gap-14 items-center">
        <div>
          <p className="aaa-eyebrow mb-3">
            <span className="inline-block w-8 h-px bg-[#ef6b6b] align-middle mr-2" />
            Get in touch
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold leading-snug">
            We are just one call away from you!
          </h2>
          <p className="mt-5 leading-relaxed max-w-md">
            We'd love to talk to you and discuss your requirements. Give us a call
            or connect with us over email.
          </p>

          <div className="mt-8 space-y-4">
            <a
              href={`mailto:${COMPANY.email}`}
              className="flex items-center gap-4 group"
            >
              <span className="w-12 h-12 rounded-xl bg-[#f2e7f0] flex items-center justify-center group-hover:bg-[#7a4fa3] transition-colors duration-300">
                <Mail size={22} className="text-[#7a4fa3] group-hover:text-white transition-colors duration-300" />
              </span>
              <span>
                <span className="block text-xs uppercase tracking-wider text-[#9b99ad]">Email</span>
                <span className="text-[#3d3b54] font-medium">{COMPANY.email}</span>
              </span>
            </a>

            <a
              href={`tel:${COMPANY.phoneHref}`}
              className="flex items-center gap-4 group"
            >
              <span className="w-12 h-12 rounded-xl bg-[#f2e7f0] flex items-center justify-center group-hover:bg-[#7a4fa3] transition-colors duration-300">
                <Phone size={22} className="text-[#7a4fa3] group-hover:text-white transition-colors duration-300" />
              </span>
              <span>
                <span className="block text-xs uppercase tracking-wider text-[#9b99ad]">Phone</span>
                <span className="text-[#3d3b54] font-medium">{COMPANY.phone}</span>
              </span>
            </a>

            <div className="flex items-center gap-4">
              <span className="w-12 h-12 rounded-xl bg-[#f2e7f0] flex items-center justify-center">
                <Printer size={22} className="text-[#7a4fa3]" />
              </span>
              <span>
                <span className="block text-xs uppercase tracking-wider text-[#9b99ad]">Fax</span>
                <span className="text-[#3d3b54] font-medium">{COMPANY.fax}</span>
              </span>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href={`mailto:${COMPANY.email}`}
              className="aaa-btn-primary px-7 py-3 rounded-md font-medium inline-flex items-center gap-2"
            >
              <Mail size={18} /> E-Mail Us
            </a>
            <a
              href={`tel:${COMPANY.phoneHref}`}
              className="border border-[#7a4fa3] text-[#7a4fa3] px-7 py-3 rounded-md font-medium inline-flex items-center gap-2 hover:bg-[#7a4fa3] hover:text-white transition-colors duration-300"
            >
              <Phone size={18} /> Call Us
            </a>
          </div>
        </div>

        <div className="relative flex justify-center">
          <div className="absolute w-72 h-72 rounded-full aaa-hero-gradient opacity-90 -z-0"
            style={{ top: "10%" }} />
          <PhoneMock className="relative w-56 md:w-64 aaa-float" />
        </div>
      </div>
    </section>
  );
};

export default Contact;
